// React
import axios from "axios";
import React, { useState, useEffect } from "react";


// Ionic
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonButton,
  IonHeader,
  IonToolbar,
  IonIcon,
  IonModal,
  IonLoading,
  IonAlert,
} from "@ionic/react";

/*import { useLocation } from 'react-router-dom';*/

import Constants from "../Context/constants";

// Components
/*** Header ***/
/*import Toolbar from "../components/Header/Toolbar";*/
/*** Search ***/
import InfoCard from "../components/Search/InfoCard";
import SearchInput from "../components/Search/SearchInput";
import Filter from "../components/Search/Filter";
import Map from "../components/Map/Map";
import Marker from "../components/Map/Marker";
import BannerTourendata from "../components/Search/BannerTourendata";
//CSS

// Packages
import { Wrapper } from "@googlemaps/react-wrapper";

// Data
import UserService from "../Context/user.service";
import ModalBookmark from "../Context/bookmark.modal";

//CSS
import {
  scanOutline,
} from "ionicons/icons";
import ClusterMarker from "../components/Map/MarkerCluster";
import userService from "../Context/user.service";
import { act } from "react-dom/test-utils";

const render = (status) => {
  return <h1>{status}</h1>;
};

function decode(str) {
  let txt = document.createElement("div");
  txt.innerHTML = str;
  var realtext = txt.innerText.replaceAll("&nbsp;", "\u00A0");
  return realtext;
}

const MOBILE_AD_MEDIA_QUERY = "(max-width: 1600px)";
const DESKTOP_AD_CONTAINER_ID = "div-gpt-ad-1781092902999-0";
const MOBILE_AD_CONTAINER_ID = "div-gpt-ad-1781092839301-0";
const DESKTOP_AD_CONTAINER_ID_2 = "div-gpt-ad-1781092951767-0";
const MOBILE_AD_CONTAINER_ID_2 = "div-gpt-ad-1781092839301-1";

// Function Component Export
function Search(props) {
  var userInitial = 0;
  var logedInInitial = false;
  var isProinitial = false;
  var tokenInitial = "";

  const tokenData = UserService.getUserData();

  // Disable Paywall Modal
  //window.parent.setPaywallModal("none");

  if (typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {
    userInitial = tokenData["tokenData"].MerchantCustomerId;
    logedInInitial = true;

    if (tokenData.login == 1) {
      logedInInitial = true;
    }
    if (tokenData.pro == 1) {
      isProinitial = true;
    }

    tokenInitial = tokenData.cookie;
  }

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPro, setIsPro] = useState(isProinitial);
  const [isLoggedIn, setIsLoggedIn] = useState(logedInInitial);
  const [user, setUser] = useState(userInitial);
  const [token, setToken] = useState(tokenInitial);
  const [pitchList, setPitchList] = useState();
  const [localprofileData, setlocalprofileData] = useState([]);
  // kostenlos RAUS NEHMEN - Nur drin damit ein Ergebnis angezeigt wird
  const [dog, setDog] = useState(false);
  const [disposal, setDisposal] = useState(false);
  const [forfree, setForfree] = useState(false);
  const [items, setItems] = useState([]);
  const [searchType, setSearchType] = useState("");
  const [searchlocation, setSearchlocation] = useState({ lat: 40, lng: 9 });
  const [previousSearch, setpreviousSearch] = useState([]);
  const [bookmark, setbookmark] = useState([]);
  const [allbookmarks, setAllBookmarks] = useState([]);
  const [previousVisible, setpreviousVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchParam] = useState(["anfahrt_d", "anfahrt_e"]);
  const [markers, setMarkers] = useState([]);
  const [mapTypeId, setmapTypeId] = useState("roadmap"); // initial zoom
  const initialRendered = false;
  const [showResultModal, setShowResultModal] = useState(false);
  const [clusterRendered, setClusterRendered] = useState(false);
  const [plusFilterValue, setPlusFilterValue] = useState("");
  const [showAreaSearchBt, setShowAreaSearchBt] = useState(true);
  const [showAreaWasClicked, setShowAreaWasClicked] = useState(false);
  const [areaSearchButtonDisabled, setAreaSearchButtonDisabled] = useState(true);
  const [profileInterests, setProfileInterests] = useState([]);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [showFilterAndBackToSearch, setshowFilterAndBackToSearch] = useState(true);
  var accessRights = [];
  var kartenbereichsuche = false;
  const zoomBreakpointAreaSearch = 8; // Zoom Level ab dem die Kartenbereichsuche aktiv ist
  const [searchRunning, setSearchRunning] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showNoResults, setShowNoResults] = useState(false);
  const [isMobileAdViewport, setIsMobileAdViewport] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return true;
    }
    return window.matchMedia(MOBILE_AD_MEDIA_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }

    const mediaQueryList = window.matchMedia(MOBILE_AD_MEDIA_QUERY);
    const handleViewportChange = (event) => {
      setIsMobileAdViewport(event.matches);
    };

    setIsMobileAdViewport(mediaQueryList.matches);
    if (typeof mediaQueryList.addEventListener === "function") {
      mediaQueryList.addEventListener("change", handleViewportChange);
    } else {
      mediaQueryList.addListener(handleViewportChange);
    }

    return () => {
      if (typeof mediaQueryList.removeEventListener === "function") {
        mediaQueryList.removeEventListener("change", handleViewportChange);
      } else {
        mediaQueryList.removeListener(handleViewportChange);
      }
    };
  }, []);
  const [showNoResultsAlert, setShowNoResultsAlert] = useState(false);

  const [hasTourenData, setHasTourenData] = useState(false);
  const [tourenName, setTourenName] = useState("Keine Route vorhanden");
  const [tourenExcerpt, setTourenExcerpt] = useState("");
  const [tourenLink, setTourenLink] = useState("");
  const [tourenImageUrl, setTourenImageUrl] = useState("");

  function tourenAbfrage(){
    setHasTourenData(false);
    if (document.querySelector("#searchinput") === null) {
      return;
    }

    if (typeof document.querySelector("#searchinput") === "undefined") {
      return;
    }

    var suchbegriff = document.querySelector("#searchinput").value;
    if(suchbegriff !== "" && suchbegriff !== "Kartenbereich") {
      UserService.getTourenArray().then(
        (response) => {
          var tourenArray = response.data;
          for (var i = 0; i < tourenArray.length; i++) {
            if (tourenArray[i].acf.tag.toLowerCase().search(suchbegriff.toLowerCase()) >= 0) {
              setTourenName(tourenArray[i].title.rendered);
              setTourenExcerpt(tourenArray[i].excerpt.rendered);
              setTourenImageUrl(
                tourenArray[i]._embedded["wp:featuredmedia"][0].source_url
              );
              setTourenLink(tourenArray[i].link);
              setHasTourenData(true);
              break;
            }
          }
        },
        (error) => {
          setError(error);
        }
      );
    }
  } 

  const pid = user;

  const defaultValueFilter = {
    address: "",
    features: [],
    underground: [],
    interests: [],
    searchinput: "",
    searchstring: "",
    typePitch: true,
    typePitchEntsorgung: false,
    typeService: false,
    gespanneErlaubt: false,
    voucher: false,
    price: { lower: 0, upper: 30 },
    vehicle_length: { lower: 4, upper: 15 },
    noofpitches: { lower: 1, upper: 40 },
    ve: 0,
  };

  window.allMarker = [];

  if (isProinitial === true) {
    //defaultValueFilter.typeService = true;
  }

  const [activeFilter, setActiveFilter] = useState(defaultValueFilter);

  function sameFilterValue(field){
    if(JSON.stringify(activeFilter[field]) === JSON.stringify(defaultValueFilter[field])){
      return true;
    } else {
      return false;
    }
  }

  function filterIsSet() {
    if(!sameFilterValue('features')){
      return true;
    }
    if(!sameFilterValue('gespanneErlaubt')){
      return true;
    }
    if(!sameFilterValue('interests')){
      return true;
    }
    if(!sameFilterValue('noofpitches')){
      return true;
    }
    if(!sameFilterValue('price')){
      return true;
    }
    if(!sameFilterValue('typePitch')){
      return true;
    }
    if(!sameFilterValue('typeService')){
      return true;
    }
    if(!sameFilterValue('typePitchEntsorgung')){
      return true;
    }
    if(!sameFilterValue('underground')){
      return true;
    }
    if(!sameFilterValue('vehicle_length')){
      return true;
    }
    if(!sameFilterValue('voucher')){
      return true;
    }
    return false;
  }

  const sendSearch = function () {
    setTimeout(function () {
      handleSearchSubmit();
    }, 150);
  };



  const interestsCat = [];

  for (const key in Constants.interests) {
    interestsCat.push(key);
  }

  function removeAllItems() {
    setItems([]);
    setClusterRendered(false);
    if (typeof window.markers !== "undefined" && window.markers !== null) {
      window.markers.forEach((marker) => {
        marker.setMap(null);
      });
      window.markers = null;
    }
    if (typeof window.Clusterer !== "undefined" && window.Clusterer !== null) {
      window.Clusterer.setMap(null);
    }
  }

  const setMapCenter = (items) => {
    if(typeof items !== "undefined") {
      var bounds = new window.google.maps.LatLngBounds();
      items.forEach((item) => {
        var cords = new window.google.maps.LatLng(
            item.gps.latitude,
            item.gps.longitude
        );
        if(item.gps.latitude == '' || item.gps.longitude == '') {
          return;
        }
        else{
          bounds.extend(cords);
        }
      });

      if(!kartenbereichsuche) {
        // und auch die Suchposition mit einbeziehen
        if (typeof window.search_marker !== "undefined" && window.search_marker.getPosition().lat.length > 0) {
          bounds.extend(window.search_marker.getPosition());
        }
        window.gmap.fitBounds(bounds);
        setTimeout(function () {
          var currentZoom = window.gmap.getZoom();
          // check here if window.search_marker.getPosition() is in visible area, otherwise reduce zoom one step until it fits
          if (window.search_marker && window.search_marker.getPosition()) {
            var searchMarkerPosition = window.search_marker.getPosition();
            if (!window.gmap.getBounds().contains(searchMarkerPosition)) {
              while (!window.gmap.getBounds().contains(searchMarkerPosition) && currentZoom > 2) {
                currentZoom--;
                window.gmap.setZoom(currentZoom);
              }
            }
          }
        }, 100);
      }
      setAreaSearchButtonDisabled(true);
    }
  };

  const centerMap = (lat, lng) => {
    if (typeof window.gmap !== "undefined") {
      var center = new window.google.maps.LatLng(lat, lng);
      window.gmap.setCenter(center);
    } else {
      console.log("Google Map not loaded yet");
    }
  }

  if (
    typeof window.parent.seturl !== "undefined" &&
    window.self.location.href.indexOf("home") !== -1
  ) {
    setTimeout(function () {
      window.parent.seturl("search", "");
    }, 350);
  }

  useEffect(() => {
    // This runs after activeFilter changes
    sendSearch();
  }, [activeFilter]);  

  useEffect(() => {
    // GPT display must be triggered after the ad container is in the DOM.
    const debugPrefix = "[GPT-DEBUG]";

    if (isLoggedIn && isPro) {
      console.info(debugPrefix, "Skipping ad display for logged-in pro user");
      return;
    }

    let retries = 0;
    const maxRetries = 20;
    const adTargets = isMobileAdViewport
      ? [
          {
            adContainerId: MOBILE_AD_CONTAINER_ID,
            adSlot: window.__baGptSearchSlotMobile,
            expectedContainer: items.length > 0,
          },
          {
            adContainerId: MOBILE_AD_CONTAINER_ID_2,
            adSlot: window.__baGptSearchSlotMobile2,
            expectedContainer: items.length > 2,
          },
        ]
      : [
          {
            adContainerId: DESKTOP_AD_CONTAINER_ID,
            adSlot: window.__baGptSearchSlotDesktop,
            expectedContainer: items.length > 0,
          },
          {
            adContainerId: DESKTOP_AD_CONTAINER_ID_2,
            adSlot: window.__baGptSearchSlotDesktop2,
            expectedContainer: items.length > 2,
          },
        ];
    const displayedByContainer =
      window.__baGptSlotDisplayedByContainer ||
      (window.__baGptSlotDisplayedByContainer = {});
    const queuedByContainer =
      window.__baGptDisplayQueuedByContainer ||
      (window.__baGptDisplayQueuedByContainer = {});

    const slotIsRenderedInContainer = (container) => {
      if (!container) {
        return false;
      }
      return (
        container.querySelector("iframe") !== null ||
        container.hasAttribute("data-google-query-id")
      );
    };

    console.info(debugPrefix, "Ad effect started", {
      itemsCount: items.length,
      isLoggedIn,
      isPro,
      isMobileAdViewport,
      adTargets: adTargets.map((target) => target.adContainerId),
    });

    const tryDisplayAd = ({ adContainerId, adSlot, expectedContainer }) => {
      if (!expectedContainer) {
        return true;
      }

      const adContainer = document.getElementById(adContainerId);

      if (slotIsRenderedInContainer(adContainer)) {
        displayedByContainer[adContainerId] = true;
        console.info(debugPrefix, "Slot already rendered in current container, skip");
        return true;
      }

      if (queuedByContainer[adContainerId]) {
        console.info(debugPrefix, "Display already queued, wait");
        return true;
      }

      if (!adContainer || typeof window.googletag === "undefined") {
        console.info(debugPrefix, "Not ready yet", {
          hasContainer: !!adContainer,
          hasGoogletag: typeof window.googletag !== "undefined",
        });
        return false;
      }

      if (slotIsRenderedInContainer(adContainer)) {
        displayedByContainer[adContainerId] = true;
        console.info(debugPrefix, "Slot already present in container");
        return true;
      }

      const shouldRefresh = !!displayedByContainer[adContainerId] && !!adSlot;
      console.info(debugPrefix, shouldRefresh ? "Queueing refresh call" : "Queueing display call");
      queuedByContainer[adContainerId] = true;
      window.googletag.cmd.push(function () {
        const currentContainer = document.getElementById(adContainerId);
        if (!currentContainer) {
          queuedByContainer[adContainerId] = false;
          console.info(debugPrefix, "Display callback skipped, container missing");
          return;
        }
        if (slotIsRenderedInContainer(currentContainer)) {
          queuedByContainer[adContainerId] = false;
          displayedByContainer[adContainerId] = true;
          console.info(debugPrefix, "Display callback skipped, slot already present");
          return;
        }
        if (shouldRefresh && typeof window.googletag.pubads === "function") {
          console.info(debugPrefix, "Calling googletag.pubads().refresh", { adContainerId });
          window.googletag.pubads().refresh([adSlot]);
        } else {
          console.info(debugPrefix, "Calling googletag.display", { adContainerId });
          window.googletag.display(adContainerId);
        }
        queuedByContainer[adContainerId] = false;
        displayedByContainer[adContainerId] = true;
        console.info(debugPrefix, shouldRefresh ? "Refresh call done, slot marked displayed" : "Display call done, slot marked displayed");
      });

      return true;
    };

    const tryDisplayAllAds = () => {
      let allReady = true;

      adTargets.forEach((target) => {
        const displayed = tryDisplayAd(target);
        if (!displayed) {
          allReady = false;
        }
      });

      return allReady;
    };

    if (tryDisplayAllAds()) {
      return;
    }

    const retryTimer = window.setInterval(function () {
      retries++;
      const displayed = tryDisplayAllAds();
      if (displayed) {
        console.info(debugPrefix, "Display succeeded after retry", { retries });
      }
      if (displayed || retries >= maxRetries) {
        if (retries >= maxRetries && !displayed) {
          console.warn(debugPrefix, "Giving up after max retries", {
            maxRetries,
            hasContainer1: !!document.getElementById(adTargets[0].adContainerId),
            hasContainer2: !!document.getElementById(adTargets[1].adContainerId),
            hasGoogletag: typeof window.googletag !== "undefined",
          });
        }
        window.clearInterval(retryTimer);
      }
    }, 250);

    return () => {
      window.clearInterval(retryTimer);
    };
  }, [items, isLoggedIn, isPro, isMobileAdViewport]);

  /*************************  GET PREVIOUS SEARCH + BOOMARK + FILTER DATA ON LOAD************************* */
  useEffect(() => {
    // Set Parameter
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("special")) {
      setPlusFilterValue(urlParams.get("special"));
    }

    // recenter map if hisitory back
    window.onpopstate = () => {
      if (window.location.href.indexOf("/home") !== -1) {
        setIsLoaded(false);
        setIsLoaded(true);
        setTimeout(function () {
          setMapCenter(window.gmap.items);
          handleSearchFocus();
          setTimeout(function () {
            handleSearchBlur();
          }, 300);
        }, 150);
      }
    };

    // Get Previous Results if User is Pro Member
    isLoggedIn &&
      UserService.getPreviousSearchs(pid, token).then(
        (response) => {
          var revSearches = response.data[0].lastsearch.reverse();
          setpreviousSearch(revSearches);
          //setIsLoaded(true);
        },
        (error) => {
          setError(error);
        }
      );
    // Get Bookmark Results if User is Pro Member
    isLoggedIn &&
      UserService.getBookmarks(pid, token).then(
        (response) => {
          setbookmark(response.data);

          var allb = [];
          response.data.lists.forEach((list) => {
            list.items.forEach((item) => {
              if (typeof item === "number") {
                allb.push(item);
              }
            });
          });

          //setAllBookmarks
          setAllBookmarks(allb);
          setIsLoaded(true);
        },
        (error) => {
          setError(error);
        }
      );

    isLoggedIn &&
      UserService.getPelnigoAccessItemsFromAPI(pid, token).then(
        (response) => {
          accessRights = response.data.items;
          window.accessRights = response.data.items;
        },
        (error) => {
          console.log(error);
        }
      );

    //preselect search if WP Search is active
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const paramsKeys = Object.keys(params);
    const onlySsoSession = paramsKeys.length === 1 && paramsKeys[0] === "sso_session";

    if ((typeof params !== "undefined" || typeof params.s !== "undefined") &&
  onlySsoSession === false) {
      if (typeof params.s !== "undefined") {
        setTimeout(function () {
          setSearchText(params.s);
          document.querySelector(".search__button").click();
        }, 500);
      } else if (typeof params.special !== "undefined" && params.special !== null) {
        setshowFilterAndBackToSearch(false);
        setTimeout(function () {
          fireSearch("&hasfilter=1&special=" + params.special);
        }, 500);
      } else if (typeof params.ids !== "undefined" && params.ids !== null) {
        setshowFilterAndBackToSearch(false);
        setTimeout(function () {
          fireSearch("&hasfilter=1&ids=" + params.ids);
        }, 500);
      } else if (typeof params.tag !== "undefined" && params.tag !== null) {
        setshowFilterAndBackToSearch(false);
        setTimeout(function () {
          fireSearch("&hasfilter=1&tag=" + params.tag);
        }, 500);
      } else if (typeof params.typ !== "undefined" && params.typ !== null) {
        setTimeout(function () {
          fireSearch("&hasfilter=1&typ=" + params.typ);
        }, 500);
      } else {
        setTimeout(function () {
          fireSearch();
        }, 500);
      }
    } else {
      // previous search
      if (localStorage.getItem("ba-filter") !== null) {
        var prefilter = JSON.parse(localStorage.getItem("ba-filter"));

        setActiveFilter(prefilter);
        setSearchText(prefilter.address);

        setTimeout(function () {
          fireSearch(prefilter.searchstring);
        }, 350);
      } else {
        // load default data
        UserService.getPublicContent("", isPro).then(
          (response) => {
            if (response.data.data.length > 0) {
              removeAllItems();
              setItems(response.data.data);
              setSearchType(response.data.type);
              setSearchlocation(response.data.searchpos);
              setIsLoaded(true);

              if(!kartenbereichsuche) {
                setMapCenter(response.data.data);
              }

              setSearchMarker(response);
            } else {
              // nix gefunden? Dann trotzdem zum Ort auf der Karte springen
              //setShowResultModal(true);
            }
          },
          (error) => {
            setError(error);
          }
        );
      }
    }

    // Load previous search

    // Only get User Profile
    if (isLoggedIn && isPro) {
      UserService.getProfileFields(user, token).then((response) => {
        setProfileInterests(response.data[0].interests);

        if (
          typeof response.data[0] !== "undefined" &&
          response.data[0].crew.indexOf("Mit Hund") !== -1
        ) {
          //setDog(true);
        } /*else if (key === "forfree") {
          setForfree(true);
        } else if (key === "disposal") {
          setDisposal(true);
        }*/
      });
    }
    if (!isLoggedIn) {
      setIsLoaded(true);
    }
  }, []);

  const setSearchMarker = (response) => {
    if(response.data.type === "special_ids" || response.data.type === "special_tags" || response.data.type === "special_stellplatztyp") {
    }
    else{
      if (typeof response.data.searchpos !== "undefined") {
        var search_marker = new window.google.maps.Marker({
          position: {
            lat: response.data.searchpos.lat * 1,
            lng: response.data.searchpos.lng * 1,
          },
          title: "Standort",
        });
        if (typeof window.search_marker !== "undefined") {
          window.search_marker.setMap(null);
        }
        window.search_marker = search_marker;
        window.search_marker.setMap(window.gmap);
      }
    }
  };

  /*******************************************  SEARCH INPUT HANDLERS ********************************** */
  const handleSearchTextChange = (e) => {
    if(e === "Kartenbereich") {
      kartenbereichsuche = true;
    }
    else {
      kartenbereichsuche = false;
    }
    setSearchText(e);
  };

  const updatePrevSearch = (previousSearchinput) => {
    if (previousSearchinput === "" || isLoggedIn === false) {
      return false;
    }

    setpreviousSearch(previousSearchinput);
    var previousSearchString = previousSearchinput.join(",");

    try {
      const response = axios.post(
        window.location.origin +
          "/api/?action=update_lastsearch&pid=" +
          pid +
          "&lastsearch=" +
          previousSearchString +
          "&token=" +
          token,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleAreaSearch = () => {
    // show wait info until search is done
    setSearchRunning(true);
    document
      .getElementById("searchinput")
      .setAttribute("data-lat", window.gmap.getCenter().lat());
    document
      .getElementById("searchinput")
      .setAttribute("data-lng", window.gmap.getCenter().lng());
    setSearchText("Kartenbereich");
    kartenbereichsuche = true;
    handleSearchSubmit();
    setShowAreaWasClicked(true);
    setAreaSearchButtonDisabled(true);
  };


  const handleSearchSubmit = (e) => {
    // Hide the previous searchs and bookmarks
    setpreviousVisible(false);

    var baFilter = activeFilter;

    // Location search
    var searchstring = "&hasfilter=1";
    var searchinput = document.querySelector("#searchinput").value;
    var latitude = document.getElementById("searchinput").getAttribute("data-lat");
    var longitude = document.getElementById("searchinput").getAttribute("data-lng");

    if (typeof searchinput !== "undefined" && searchinput != "") {
      if (searchinput === "Kartenbereich") {
        kartenbereichsuche = true;
        centerMap(latitude, longitude);
        //searchstring += "&lat=" + window.gmap.getCenter().lat() + "&lng=" + window.gmap.getCenter().lng();
        baFilter["address"] = "";
      } else {
        searchstring += "&address=" + searchinput;
        baFilter["address"] = searchinput;

        //check and add to lastsearch
        if (previousSearch.indexOf(searchinput) === -1) {
          previousSearch.push(searchinput);
        } else {
          previousSearch.splice(previousSearch.indexOf(searchinput), 1);
          previousSearch.unshift(searchinput);
        }
        updatePrevSearch(previousSearch);
      }
    }
    //

    // buttons ---------------------------------

    // muss ich das Umbauen des Dusche-Filters dann auch hier über eine Sonderregel auffangen?

    if (
      document.querySelector("[value='disposal']") !== null &&
      document.querySelector("[value='disposal']").getAttribute("active") ==
        "true"
    ) {
      searchstring += "&ve=1";
      baFilter["ve"] = 1;
    }

    // price
    if (activeFilter.typePitch) {
      if (
        document.querySelector("#filtermodal").classList.contains("show-modal") &&
        typeof document.querySelector("#price2").value.lower !== "undefined"
      ) {
        searchstring +=
          "&price_lower=" + document.querySelector("#price2").value.lower;
        searchstring +=
          "&price_upper=" + document.querySelector("#price2").value.upper;
        baFilter["price"] = document.querySelector("#price2").value;
      } else {
        //forfree
        if (
          document.querySelector("[value='forfree']") !== null &&
          document.querySelector("[value='forfree']").getAttribute("active") ==
            "true"
        ) {
          searchstring += "&price_lower=0&price_upper=0";
          baFilter["price"] = { lower: 0, upper: 0 };
        }
      }




    }

    //filter  ---------------------------------

    //Schieberegler
    if (
      document.querySelector("#filtermodal").classList.contains("show-modal") && activeFilter.typePitch
    ) {
      //Stellplatztypen

      if (
        typeof document.querySelector("[name='type-pitch']") !== "undefined" &&
        document.querySelector("[name='type-pitch']") !== null &&
        document
          .querySelector("[name='type-pitch']")
          .classList.contains("checkbox-checked")
      ) {
        searchstring += "&pitch=1";
        baFilter["typePitch"] = true;
      } else {
        searchstring += "&pitch=0";
        baFilter["typePitch"] = false;
      }

      if (
        typeof document.querySelector("[name='type-pitch-entsorgung']") !==
          "undefined" &&
        document.querySelector("[name='type-pitch-entsorgung']") !== null &&
        document
          .querySelector("[name='type-pitch-entsorgung']")
          .classList.contains("checkbox-checked")
      ) {
        searchstring += "&typePitchEntsorgung=1";
        baFilter["typePitchEntsorgung"] = true;
      } else {
        baFilter["typePitchEntsorgung"] = false;
      }

      if (
        typeof document.querySelector("[name='type-voucher']") !==
          "undefined" &&
        document.querySelector("[name='type-voucher']") !== null &&
        document
          .querySelector("[name='type-voucher']")
          .classList.contains("checkbox-checked")
      ) {
        searchstring += "&voucher=1";
        baFilter["voucher"] = true;
      } else {
        baFilter["voucher"] = false;
      }

      if (
        typeof document.querySelector("[name='gespanneErlaubt']") !==
          "undefined" &&
        document.querySelector("[name='gespanneErlaubt']") !== null &&
        document
          .querySelector("[name='gespanneErlaubt']")
          .classList.contains("checkbox-checked")
      ) {
        searchstring += "&gespanne-erlaubt=1";
        baFilter["gespanneErlaubt"] = true;
      } else {
        searchstring += "&gespanne-erlaubt=0";
        baFilter["gespanneErlaubt"] = false;
      }

      if (
        (typeof document.querySelector("[name='type-service']") !==
          "undefined" &&
          document.querySelector("[name='type-service']") !== null &&
          document
            .querySelector("[name='type-service']")
            .classList.contains("checkbox-checked")) ||
        window.location.href.indexOf("typ=Entsorgungsstation") !== -1
      ) {
        searchstring += "&typeService=1";
        baFilter["typeService"] = true;
      } else {
        searchstring += "&typeService=0";
        baFilter["typeService"] = false;
      }

      if (
        typeof document.querySelector("#vehicle_length").value.lower !==
        "undefined"
      ) {
        searchstring +=
          "&vehicle_length_lower=" +
          document.querySelector("#vehicle_length").value.lower;
        searchstring +=
          "&vehicle_length_upper=" +
          document.querySelector("#vehicle_length").value.upper;
        baFilter["vehicle_length"] =
          document.querySelector("#vehicle_length").value;
      }

      if (
        typeof document.querySelector("#noofpitches").value.lower !==
        "undefined"
      ) {
        searchstring +=
          "&noofpitches_lower=" +
          document.querySelector("#noofpitches").value.lower;
        searchstring +=
          "&noofpitches_upper=" +
          document.querySelector("#noofpitches").value.upper;
        baFilter["noofpitches"] = document.querySelector("#noofpitches").value;
      }

      //Austattung
      Constants.austattung.forEach((element, index) => {
        if (activeFilter["features"].indexOf(element) !== -1) {
          searchstring += "&features[]=" + element;
          baFilter["features"].push(element);
        }
      });
      // unique Features
      baFilter["features"] = [...new Set(baFilter["features"])];

      //underground
      Constants.underground.forEach((element, index) => {
        if (activeFilter["underground"].indexOf(element) !== -1) {
          searchstring += "&underground[]=" + element;
          baFilter["underground"].push(element);
        }
        // unique Underground
        baFilter["underground"] = [...new Set(baFilter["underground"])];
      });

      //versorgung
      Constants.versorgung.forEach((element, index) => {
        if (activeFilter["features"].indexOf(element) !== -1) {
          searchstring += "&features[]=" + element;
          baFilter["features"].push(element);
        }
      });
      // unique Features
      baFilter["features"] = [...new Set(baFilter["features"])];

      //interests

      for (const key in Constants.interests) {
        for (const subkey in Constants.interests[key]) {
          if (
            document
              .querySelector("[value='" + subkey + "']")
              .getAttribute("aria-checked") == "true"
          ) {
            searchstring += "&interests[]=" + subkey;
            baFilter["interests"].push(subkey);
          }
        }
      }
      // unique Interests
      baFilter["interests"] = [...new Set(baFilter["interests"])];
    }
    else{
      // Filterdialog nicht offen, also searchstring und baFilter aus activeFilter übernehmen
      if (activeFilter["typePitch"] === true) {
        searchstring += "&pitch=1";
        baFilter["typePitch"] = true;
      }
      else {
        searchstring += "&pitch=0";
        baFilter["typePitch"] = false;
      }
      if (activeFilter["typePitchEntsorgung"] === true) {
        searchstring += "&typePitchEntsorgung=1";
        baFilter["typePitchEntsorgung"] = true;
      }
      else {
        searchstring += "&typePitchEntsorgung=0";
        baFilter["typePitchEntsorgung"] = false;
      }
      if (activeFilter["gespanneErlaubt"] === true) {
        searchstring += "&gespanne-erlaubt=1";
        baFilter["gespanneErlaubt"] = true;
      }
      else {
        searchstring += "&gespanne-erlaubt=0";
        baFilter["gespanneErlaubt"] = false;
      }
      if (activeFilter["voucher"] === true) {
        searchstring += "&voucher=1";
        baFilter["voucher"] = true;
      }
      else {
        baFilter["voucher"] = false;
      }
      if (activeFilter["typeService"] === true) {
        searchstring += "&typeService=1";
        baFilter["typeService"] = true;
      }
      else {
        searchstring += "&typeService=0";
        baFilter["typeService"] = false;
      }
      if (activeFilter["vehicle_length"].lower !== 4 || activeFilter["vehicle_length"].upper !== 15) {
        searchstring +=
          "&vehicle_length_lower=" + activeFilter["vehicle_length"].lower;
        searchstring +=
          "&vehicle_length_upper=" + activeFilter["vehicle_length"].upper;
        baFilter["vehicle_length"] = activeFilter["vehicle_length"];
      }
      if (activeFilter["noofpitches"].lower !== 1 || activeFilter["noofpitches"].upper !== 40) {
        searchstring +=
          "&noofpitches_lower=" + activeFilter["noofpitches"].lower;
        searchstring +=
          "&noofpitches_upper=" + activeFilter["noofpitches"].upper;
        baFilter["noofpitches"] = activeFilter["noofpitches"];
      }
      if (activeFilter["price"].lower !== 0 || activeFilter["price"].upper !== 30) {
        searchstring +=
          "&price_lower=" + activeFilter["price"].lower;
        searchstring +=
          "&price_upper=" + activeFilter["price"].upper;
        baFilter["price"] = activeFilter["price"];
      }
      // Austattung
      if (activeFilter["features"].length > 0) {
        activeFilter["features"].forEach((element, index) => {
          searchstring += "&features[]=" + element;
          baFilter["features"].push(element);
        });
      }

      // unique Features
      baFilter["features"] = [...new Set(baFilter["features"])];

      // Underground
      if (activeFilter["underground"].length > 0) {
        activeFilter["underground"].forEach((element, index) => {
          if (Constants.underground.indexOf(element) !== -1) {
            searchstring += "&underground[]=" + element;
            baFilter["underground"].push(element);
          }
        });
        // unique Underground
        baFilter["underground"] = [...new Set(baFilter["underground"])];
      }
      // Interests
      if (activeFilter["interests"].length > 0) {
        activeFilter["interests"].forEach((element, index) => {
          for (const key in Constants.interests) {
            if (Constants.interests[key].hasOwnProperty(element)) {
              searchstring += "&interests[]=" + element;
              if (baFilter["interests"].indexOf(element) === -1) {
                baFilter["interests"].push(element);
              }
            }
          }
        });
      }
    }

    searchstring += "&kartenbereichsuche=" + kartenbereichsuche;
    if (kartenbereichsuche) {
      // Get the bounds of the map
      var bounds = window.gmap.getBounds();
      if (bounds) {
        // Get the north-east and south-west corners of the bounds
        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();
        // Add the bounds to the searchstring
        searchstring +=
          "&sqare[x1]=" + ne.lat() +
          "&sqare[y1]=" + ne.lng() +
          "&sqare[x2]=" + sw.lat() +
          "&sqare[y2]=" + sw.lng();
      }
    }

    // Save Search
    baFilter["searchstring"] = searchstring;
    localStorage.setItem("ba-filter", JSON.stringify(baFilter));

    // Mark dog button as active if baFilter["features"] contains "Hunde erlaubt"
    if (baFilter["features"].indexOf("Hunde erlaubt") !== -1) {
      setDog(true);
    } else {
      setDog(false);
    }

    // Mark disposal button as active if baFilter["features"] contains "Chemietoiletten-Entsorgung", "Grauwasser-Entsorgung" and "Frischwasser"
    if (
      baFilter["features"].indexOf("Chemietoiletten-Entsorgung") !== -1 &&
      baFilter["features"].indexOf("Grauwasser-Entsorgung") !== -1 &&
      baFilter["features"].indexOf("Frischwasser") !== -1
    ) {
      setDisposal(true);
    }
    else {
      setDisposal(false);
    }

    // Mark forfree button as active if baFilter["price"] contains 0
    if (baFilter["price"].lower === 0 && baFilter["price"].upper === 0) {
      setForfree(true);
    } else {
      setForfree(false);
    }

    setLoading(true);

    // Receive Data and show Infocards + Marker
    fireSearch(searchstring);
    
  };

  const fireSearch = (searchstring) => {
    UserService.getPublicContent(searchstring, isPro).then(
      (response) => {
        const responseData = response.data.data;
        let itemList = [];
        setShowNoResults(false);

        //Touren-Abfrage für Banner in der Liste
        if((window.location.hostname === "woodstock.local" || window.location.hostname === "dev3.bordatlas.de")){
          tourenAbfrage();
        }

        // Set the filtered List to the State
        if (response.data.data.length > 0) {
          removeAllItems();
          setItems(responseData);
          setSearchType(response.data.type);
          // only if searchpos is defined
          if (typeof response.data.searchpos !== "undefined") {
            setSearchlocation(response.data.searchpos);
          }

          setIsLoaded(true);
          if(!kartenbereichsuche) {
            setSearchMarker(response);
            setMapCenter(responseData);
          }
        } 
        else{

          if (document.querySelector("#filtermodal").classList.contains("show-modal")) {
            setShowNoResults(true);
          }

        }


        /*
        else {
          if(!kartenbereichsuche){
            setShowResultModal(true);
            if (typeof response.data.searchpos !== "undefined") {
            setSearchlocation(response.data.searchpos);
              if(response.data.searchpos.lat !== 0 && response.data.searchpos.lng !== 0){
                setSearchMarker(response);
                centerMap(response.data.searchpos.lat, response.data.searchpos.lng);
              }
              else{
                centerMap(51.1657, 10.4515); // Germany Center
              }
            }
          }
          else{
            removeAllItems();
          }
        }
        */
        if(response.data.type === "special_ids" || response.data.type === "special_tags" || response.data.type === "special_stellplatztyp") {
          setShowAreaSearchBt(false);
        }
        setLoading(false);
        setSearchRunning(false);
        setAreaSearchButtonDisabled(true);
      },
      (error) => {
        setError(error);
      }
    );
  };

  const handleSearchFocus = () => {
    setpreviousVisible(true);
  };
  const handleSearchBlur = () => {
    // Delay blur function to prevent Data from disappearing to quick
    function delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    }
    delay(300).then(() => setpreviousVisible(false));
  };
  const handleDeletePreviousSelect = (e) => {
    previousSearch.splice(previousSearch.indexOf(e), 1);
    updatePrevSearch(previousSearch);
    // SEND DATA TO DB to delete
  };
  const handlePreviousSelect = (e) => {
    setSearchText(e);
    setTimeout(function () {
      handleSearchSubmit(e);
    });
  };
  const handleNormalSubmit = (e) => {
    handleSearchSubmit(searchText);
  };

  /********************************** FILTER INPUT HANDLERS *************************/


  /* FULL WIDTH MOBILE MAP */
  const handlefullWidthMap = () => {
    let mapWrapper = document.querySelector(".search__maps");
    mapWrapper.classList.toggle("fullwidth");
  };

  if (isLoaded) {
    window.parent.setPaywallModal("none");
  }

  return isLoaded ? (
    <IonPage
      className={`${isLoggedIn ? "is-logged-in" : "not-logged-in"} ${
        isPro ? "is-pro" : "not-pro"
      }`}
    >

      <ModalBookmark
        isLoggedInValue={isLoggedIn}
        isProValue={isPro}
        pid={pid}
        token={token}
        bookmark={bookmark}
        setbookmark={setbookmark}
        setIsLoaded={setIsLoaded}
      />
      <IonContent fullscreen>
        <IonAlert
          isOpen={showNoResultsAlert}
          onDidDismiss={() => setShowNoResultsAlert(false)}
          header="Keine Stellplätze gefunden"
          message="Mit Ihrer Filterauswahl wurden keine Stellplätze gefunden. Bitte passen Sie Ihre Suche oder Filter an."
          buttons={['OK']}
        />
        <IonGrid>
          <IonRow>
            <IonCol id="search__maps" className="search__maps" size="12" size-md="6" size-lg="8">
              <div style={{ display: "flex", height: "100%" }}>
                <Wrapper
                  apiKey={"AIzaSyA_F83EK6cz_LUYSGUSCdcmLDZja7Dk0ho"}
                  render={render}
                >
                  {showAreaSearchBt === true && window.location.href.indexOf("typ=Entsorgungsstation") === -1 && (
                    <IonRow className="search_area_wrapper">
                      <IonButton
                        disabled={areaSearchButtonDisabled}
                        shape="round"
                        color="secondary"
                        id="areaSearch"
                        onClick={() => handleAreaSearch()}
                        className="route__open__button search_area ion-color ion-color-secondary md button button-block button-round button-solid ion-activatable ion-focusable"
                      >
                        {areaSearchButtonDisabled && window.gmap && window.gmap.getZoom() <= zoomBreakpointAreaSearch && (
                          <>Reinzoomen und im Bereich suchen</>
                        )}
                        {areaSearchButtonDisabled && window.gmap && window.gmap.getZoom() > zoomBreakpointAreaSearch && (
                          <>Verschieben und im Bereich suchen</>
                        )}
                        {!areaSearchButtonDisabled && (
                          <>In diesem Bereich suchen</>
                        )}
                      </IonButton>
                    </IonRow>
                  )}
                  <IonButton
                    shape="round"
                    color="primary"
                    id="fullWidthMap"
                    onClick={() => handlefullWidthMap()}
                    className="fullWidthMap"
                  >
                    <IonIcon icon={scanOutline} color="light" />
                  </IonButton>
                  <Map
                    id="mainmap"
                    zoomBreakpointAreaSearch={zoomBreakpointAreaSearch}
                    setShowAreaSearchBt={setShowAreaSearchBt}
                    setAreaSearchButtonDisabled={setAreaSearchButtonDisabled}
                    style={{ flexGrow: "1", height: "100%" }}
                    mapTypeId={mapTypeId}
                    items={items}
                  >
                    {searchType != "country" &&
                      items.length <= 300 &&
                      items.map((item) => (
                        <Marker
                          position={{
                            lat: parseFloat(item.gps.latitude),
                            lng: parseFloat(item.gps.longitude),
                          }}
                          id={item.id}
                          name={item.stellplatzname}
                          marker={item.stellplatztyp}
                          premium={item.premium}
                        />
                      ))}

                    {(searchType == "country" || items.length > 300) && (
                      <div id={"clustermap"}>
                        <ClusterMarker
                          setClusterRendered={setClusterRendered}
                          items={items}
                        />
                      </div>
                    )}
                  </Map>
                </Wrapper>
              </div>
            </IonCol>
            <IonCol
              className="search__infocard"
              id="search__infocard"
              size="12"
              size-md="6"
              size-lg="4"
            >
              <div
                className={`${
                  window.location.href.indexOf("typ=Entsorgungsstation") !== -1
                    ? "forceshow search__inputWrapper"
                    : "search__inputWrapper"
                }`}
              >
                {(function () {
                  if (window.location.hash != "#nosearch") {
                    return (
                      <SearchInput
                        value={searchText}
                        onSearchTextChange={handleSearchTextChange}
                        onSearchSubmit={handleNormalSubmit}
                        onSearchFocus={handleSearchFocus}
                        onSearchBlur={handleSearchBlur}
                        onPreviousSelect={handlePreviousSelect}
                        deletePreviousSelect={handleDeletePreviousSelect}
                        previousVisibleValue={previousVisible}
                        isLoggedInValue={isLoggedIn}
                        isProValue={isPro}
                        previousSearchValue={previousSearch}
                        bookmarkValue={bookmark}
                        activeFilter={activeFilter}
                        setActiveFilter={setActiveFilter}
                        setSearchText={setSearchText}
                      />
                    );
                  }
                })()}

                {(function () {
                  if (window.location.hash != "#nosearch") {
                    
                    return (
                      <Filter
                        isLoggedInValue={isLoggedIn}
                        isProValue={isPro}
                        dogValue={dog}
                        setDog={setDog}
                        disposalValue={disposal}
                        setDisposal={setDisposal}
                        forfreeValue={forfree}
                        setForfree={setForfree}
                        sendSearch={sendSearch}
                        versorgung={Constants.versorgung}
                        austattung={Constants.austattung}
                        underground={Constants.underground}
                        interests={Constants.interests}
                        interestsCat={interestsCat}
                        activeFilter={activeFilter}
                        setActiveFilter={setActiveFilter}
                        initialRendered={initialRendered}
                        fireSearch={fireSearch}
                        filterIsSet={filterIsSet}
                        defaultValueFilter={defaultValueFilter}
                        loading={loading}
                        showNoResults={showNoResults}
                        setShowNoResults={setShowNoResults}
                      />
                    );
                  } else if (
                    window.location.hash === "#nosearch" &&
                    window.location.href.indexOf("map") !== -1
                  ) {
                    return (
                      <>
                        {showFilterAndBackToSearch === true ? (
                          <h3 className="ion-padding-start">
                            +Filter: {plusFilterValue}
                          </h3>
                        ) : (<></>)}
                        <h5 className="ion-padding-start">
                          {items.length} Stellplätze gefunden
                        </h5>
                        {showFilterAndBackToSearch === true ? (
                          <a onClick={() => userService.goToURL("/stellplatz/")}>
                          <IonButton shape="round" expand="block">
                            Zurück zur Suche
                          </IonButton>
                        </a>
                        ) : (<></>)}
                        <br />

                        {plusFilterValue === "Bauernhöfe" ? (
                          <a
                            onClick={() =>
                              userService.goToURL("/specials-item/bauernhoefe/")
                            }
                          >
                            <img src="/wp-content/uploads/2023/06/BannerStellplatzPlusBauernhoefebeiPlusFilter.jpg" alt="Landerlebnis mit dem Wohnmobil" className="special__crosslinkimg"/>
                          </a>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  }
                })()}
              </div>

              <IonLoading
                isOpen={searchRunning}
                spinner="crescent"
                message="Bitte warten..."
                backdropDismiss={false}
              />

              {items.length === 0 && (
                <div className="ion-padding">
                  <h3>Keine Stellplätze gefunden</h3>
                  <p>
                    Bitte passe deine Suche an oder erweitere deinen Suchradius.
                  </p>
                </div>
              )}

              {items.map((item, idx) => {
                if (
                  typeof item.features === "undefined" ||
                  item.features === null
                ) {
                  item.features = {
                    feature: [],
                  };
                }

                var fav = false;
                if (allbookmarks.indexOf(item.id) !== -1) {
                  fav = true;
                }

                if (typeof item.place === "undefined") {
                  item.place = { maxLengthOfPitches: "" };
                }
                if (typeof item.search === "undefined") {
                  item.search = { price: "" };
                }
                if (typeof item.basicCosts === "undefined") {
                  item.basicCosts = { currency: "" };
                }
                if (typeof item.vouchers === "undefined") {
                  item.vouchers = { voucher: [] };
                }
                if (typeof item.prices === "undefined") {
                  item.prices = { generalPrice: "" };
                }

                return (
                  <>
                    <InfoCard
                      key={item.id}
                      id={item.id}
                      slug={item.slug}
                      name={item.stellplatzname}
                      url={item.mainimage}
                      description={item.description}
                      latitude={parseFloat(item.gps.latitude)}
                      longitude={parseFloat(item.gps.longitude)}
                      distance={parseFloat(item.distance)}
                      stellplaetzeLaenge={item.place.maxLengthOfPitches}
                      vergleichspreis={item.search.price}
                      preiseWaehrung={item.basicCosts.currency}
                      voucher={item.vouchers.voucher}
                      ausstattung={item.features.feature}
                      premium={item.premium}
                      fav={fav}
                      city={item.city}
                      country={item.countryName}
                      responseType={searchType}
                      stellplatztyp={item.stellplatztyp}
                      entsorgungsstation={item.entsorgungsstation}
                      interests={profileInterests}
                      category={item.category}
                      subcategories={item.subcategories}
                      interesttags={item.tags}
                      labelpreis={item.prices.generalPrice}
                    />

                    {idx === 0 && (!isLoggedIn || !isPro) && (
                      <div class="container">
                          <div
                            id={isMobileAdViewport ? MOBILE_AD_CONTAINER_ID : DESKTOP_AD_CONTAINER_ID}
                            style={{ minWidth: isMobileAdViewport ? "320px" : "640px", minHeight: isMobileAdViewport ? "100px" : "200px" }}
                          />
                      </div>
                    )}

                    {idx === 1 && (!isLoggedIn || !isPro) && (
                      <div class="container">
                          <div
                            id={isMobileAdViewport ? MOBILE_AD_CONTAINER_ID_2 : DESKTOP_AD_CONTAINER_ID_2}
                            style={{ minWidth: isMobileAdViewport ? "320px" : "640px", minHeight: isMobileAdViewport ? "100px" : "200px" }}
                          />
                      </div>
                    )}


                    {idx === 2 && hasTourenData && (
                      <BannerTourendata 
                        tourenName={tourenName}
                        tourenExcerpt={decode(tourenExcerpt)}
                        tourenImageUrl={tourenImageUrl}
                        tourenLink={tourenLink} 
                      />
                    )}
                  </>
                );
              })}
              {/*  {search(items).map((item) => {
                return (
                  <InfoCard
                    id={item.id}
                    name={item.name}
                    url={
                      "https://images.unsplash.com/photo-1515876305430-f06edab8282a?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770"
                    }
                    description={item.description}
                    latitude={item.location.latitude}
                    longitude={item.location.longitude}
                    stellplaetzeLaenge={item.legacy_data.stellplaetze_laenge}
                    vergleichspreis={item.legacy_data.vergleichspreis}
                    preiseWaehrung={item.legacy_data.preise_waehrung}
                  />
                );
              })} */}
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonModal
          isOpen={showResultModal}
          id="showResultModal"
          onWillDismiss={() => setShowResultModal(false)}
        >
          <IonHeader>
            <IonToolbar>
              <h4 className="ion-padding-start">Kein Ergebnis</h4>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <p className="ion-padding-start">
              Leider kein Ergebnis für diese Suche in dieser Region. Bitte passe
              deine Suche oder deine Suchregion an.
            </p>
            <p className="ion-padding-start">
              <IonButton
                onClick={() => setShowResultModal(false)}
                color="primary"
              >
                Zurück zur Suche
              </IonButton>
            </p>
          </IonContent>
        </IonModal>

        {/*
        <IonModal isOpen={showModalDetail} cssClass="entsorgungs-modal">

          <div id="showModalDetailContent"></div>
          <IonButton onClick={() => setShowModalDetail(false)}>Close Modal</IonButton>
        </IonModal>
        <IonButton id="setShowModalDetail" onClick={() => setShowModalDetail(true)}>Show Modal</IonButton>*/}
      </IonContent>
    </IonPage>
  ) : (
    <></>
  );
}

export default Search;
